import PropTypes from 'prop-types';
import { Component } from 'react';

import styles from './IndexDocumentDataEntry.scss';
import DocumentTypePicker from 'indexDocuments/components/DocumentTypePicker/DocumentTypePicker';
import DescriptorList from 'indexDocuments/components/DescriptorList/DescriptorList';
import IndexDocumentActions from 'indexDocuments/components/IndexDocumentActions/IndexDocumentActions';
import descriptorPropType from 'indexDocuments/util/descriptorPropType';

class IndexDocumentDataEntry extends Component {
    render() {
        const {
            binder,
            documentTypesVisibility,
            documentTypeFilter,
            documentTypes,
            selectedDocumentType,
            indexingType,
            descriptors,
            isConversionSuccessful,
        } = this.props;

        return (
            <div className={styles.indexDocumentDataEntry} data-cy="IndexDocumentDataEntry">
                <DocumentTypePicker
                    documentTypesVisibility={documentTypesVisibility}
                    documentTypeFilter={documentTypeFilter}
                    documentTypes={documentTypes}
                    selectedDocumentType={selectedDocumentType}
                    indexingType={indexingType}/>
                <DescriptorList
                    descriptors={descriptors}
                    documentTypesVisibility={documentTypesVisibility}/>
                <IndexDocumentActions
                    binder={binder}
                    indexingType={indexingType}
                    isConversionSuccessful={isConversionSuccessful}/>
            </div>
        );
    }
}

IndexDocumentDataEntry.propTypes = {
    documentTypesVisibility: PropTypes.bool.isRequired,
    documentTypeFilter: PropTypes.string.isRequired,
    indexingType: PropTypes.string.isRequired,
    documentTypes: PropTypes.objectOf(PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
    })),
    selectedDocumentType: PropTypes.shape({
        id: PropTypes.string.isRequired,
        displayName: PropTypes.string.isRequired,
    }),
    descriptors: PropTypes.objectOf(descriptorPropType),
};

export default IndexDocumentDataEntry;